import React from 'react';
import { useField } from 'formik';

interface IProps {
  name: string;
  labelText: string;
  disabled?: boolean;
}

const Checkbox = ({ name, labelText, disabled = false }: IProps) => {
  const [field, meta] = useField(name);

  return (
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id={field.name}
        {...field}
        checked={field.value}
        disabled={disabled}
      />
      <label className="form-check-label" htmlFor={field.name}>
        {labelText}
      </label>
        {meta.error && <p className="error-wrapper">{meta.error}</p>}
    </div>
  );
};
export { Checkbox };
